import React from 'react';
import PropTypes from 'prop-types';
import { alpha, useTheme } from '@material-ui/core';
import Box from '@material-ui/core/Box';

const GlassCard = ({ children, hover = true, accentColor, accentPalette = 'primary', sx = {}, ...props }) => {
  const theme = useTheme();
  const accent = accentColor || theme.palette[accentPalette]?.main || theme.palette.primary.main;

  return (
    <Box
      {...props}
      sx={{
        height: '100%',
        borderRadius: 3,
        bgcolor: alpha(theme.palette.common.white, 0.88),
        border: `1px solid ${alpha(theme.palette.divider, 0.9)}`,
        boxShadow: `0 10px 30px ${alpha(theme.palette.common.black, 0.05)}`,
        transition: hover ? 'transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease' : 'none',
        overflow: 'hidden',
        ...(hover && {
          '&:hover': {
            transform: 'translateY(-6px)',
            borderColor: alpha(accent, 0.28),
            boxShadow: `0 22px 50px ${alpha(accent, 0.14)}`,
          },
        }),
        ...sx,
      }}
    >
      {children}
    </Box>
  );
};

GlassCard.propTypes = {
  children: PropTypes.node.isRequired,
  hover: PropTypes.bool,
  accentColor: PropTypes.string,
  accentPalette: PropTypes.string,
  sx: PropTypes.object,
};

export default GlassCard;
